import { apiClient } from './client'
import type { NotificationItem } from '@/types/user'

export const notificationsApi = {
  list: (params: { page?: number; limit?: number; type?: string } = {}) =>
    apiClient.get<{ notifications: NotificationItem[]; notificationsCount?: number }>('/api/notifications', { params }).then((r) => r.data),
  count: () => apiClient.get<{ notificationsCount: number }>('/api/notifications/getCount').then((r) => r.data.notificationsCount ?? 0),
  markRead: (ids: number[]) => apiClient.post<{ read: number }>('/api/notifications/read', { resultIds: ids }).then((r) => r.data),
  inboxUnseen: () =>
    apiClient
      .get<Array<{ id: number; seen_by: string | null }> | string>('/api/inbox/unseen')
      .then((r) => (Array.isArray(r.data) ? r.data : [])),
}
